import { render, staticRenderFns } from "./AppHelpbox.vue?vue&type=template&id=250d0886&scoped=true"
import script from "./AppHelpbox.vue?vue&type=script&lang=js"
export * from "./AppHelpbox.vue?vue&type=script&lang=js"
import style0 from "./AppHelpbox.vue?vue&type=style&index=0&id=250d0886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250d0886",
  null
  
)

export default component.exports